import { StringValues } from '../interfaces/undetermined';

// REGEXP: Constante que guarda las expresiones regulares con las cuales se validarán los formularios
export const REGEXP: StringValues = {
    fullDate: "(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))",
    shortDate: "(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9]|3[0-1])|(?:(?:0[1-9]|1[0-2])))",
    text: "([$%áéíóúüÁÉÍÓÚÜa-zA-ZñÑ0-9()_,;:+./& -]){1,255}",
    shortAlphanumeric: "([áéíóúüÁÉÍÓÚÜa-zA-ZñÑ0-9]){1,255}",
    alphanumeric: "([áéíóúüÁÉÍÓÚÜa-zA-ZñÑ0-9-.]){1,255}",
    zeroYear: "(?:(?:19|20)[0-9]{2}|0)",
    negativeNumber: "([0-9.-]{1,20})",
    month: "(?:0[1-9]|1[0-2]|[1-9])",
    onlyNumber: "([0-9]{1,20})",
    year: "(?:19|20)[0-9]{2}",
    number: "([0-9.]){1,20}",
};
